import React from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  return (
    <Link to={`/product/${product.id}`} className="group block" data-testid={`product-card-${product.id}`}>
      <div className="relative overflow-hidden bg-[#121212] aspect-[3/4]">
        <img src={product.image_url} alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
        <div className="absolute top-3 left-3 overline" style={{background:"rgba(10,10,10,0.65)", padding:"4px 10px"}}>{product.category}</div>
      </div>
      <div className="pt-4">
        <h3 className="font-body text-base text-white group-hover:text-[var(--davide-gold)] transition-colors">{product.name}</h3>
        <p className="text-[var(--davide-gold)] font-display text-lg mt-1">${product.price.toFixed(2)}</p>
      </div>
    </Link>
  );
}
